
import {watchInitStudentBinder} from './studentBinderSagas';

const studentBinderSagas = [
  watchInitStudentBinder,
];

export default studentBinderSagas;
